import { render, staticRenderFns } from "./TextBlockLayoutSelector.vue?vue&type=template&id=425ce0de&scoped=true&"
import script from "./TextBlockLayoutSelector.vue?vue&type=script&lang=js&"
export * from "./TextBlockLayoutSelector.vue?vue&type=script&lang=js&"
import style0 from "./TextBlockLayoutSelector.vue?vue&type=style&index=0&id=425ce0de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425ce0de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
